<section class="detalle-inventario">
	<div class="detalle-inventario-nombre">
		<figure>
			<img [src]=" fnGetImage() " [alt]="newProducto.nombre" loading="lazy"/>
		</figure>
		<h1>
			{{ newProducto.nombre }} {{ newProducto.currentProducto.color.nombre }} {{ newProducto.currentProducto.talla.nombre }}
		</h1>
	</div>
	<section class="detalle-inventario-precios">
		<div>
			<label>Cantidad</label>
			<p>{{ newProducto.currentProducto.cantidad }}</p>
		</div>
		<div>
			<label>Precio Unitario</label>
			<p>{{ newProducto.precio | currency:newDivisa:'symbol':'.2-2' }}</p>
		</div>
		<div>
			<label>Total</label>
			<p>{{ (newProducto.precio * newProducto.currentProducto.cantidad) | currency:newDivisa:'symbol':'.2-2' }}</p>
		</div>
	</section>
	<div class="detalle-inventario-eliminar" *ngIf=" newTipo === 1 ">
		<button class="background-blue" title="Eliminar producto">
			<p class="color-white">
				<i class="color-white far fa-trash-alt"></i> Eliminar producto
			</p>
		</button>
	</div>
</section>